var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAppGallery = function SvgIconAppGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    fillRule: "evenodd",
    d: "M16.436 3H8.564C4.847 3 3.5 4.366 3.5 8.064v7.872C3.5 19.653 4.866 21 8.564 21h7.872c3.717 0 5.064-1.366 5.064-5.064V8.064C21.519 4.366 20.153 3 16.436 3",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.064 12.009h.474v2.352h-.474v-.949H5.983v.949h-.474v-2.352h.474v.948h1.081zm2.693 1.346c0 .38-.19.588-.53.588-.342 0-.532-.208-.532-.607V12.01h-.474v1.346c0 .664.36 1.044 1.005 1.044s1.025-.38 1.025-1.062v-1.328h-.475v1.346zm5.52.266-.531-1.612h-.399l-.53 1.612-.513-1.612h-.512l.816 2.352h.398l.531-1.556.531 1.556h.399l.815-2.352h-.493zm1.878-.266h.872v-.436h-.872v-.474h1.27v-.436H16.7v2.352h1.783v-.437h-1.308v-.569zm1.877 1.006h.474v-2.352h-.474zm-7.852-.493-.209.493h-.493l1.024-2.352h.418l1.024 2.352h-.493l-.209-.493zm.17-.418h.721l-.36-.834zM12.507 9.013A3.003 3.003 0 0 1 9.51 6.016h.417a2.58 2.58 0 0 0 2.58 2.58 2.58 2.58 0 0 0 2.58-2.58h.417a3.003 3.003 0 0 1-2.997 2.997"
  }))));
};
export default SvgIconAppGallery;